import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

// Import the actual logo
import logoImage from '../assets/images/floboys_logo.PNG';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src={logoImage} 
                alt="Floboys Surface Cleaning LLC Logo" 
                className="h-16 w-auto"
              />
              <span className="sr-only">Floboys Surface Cleaning LLC</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-forest-700 hover:text-forest-500 font-medium">Home</Link>
            <Link to="/services" className="text-forest-700 hover:text-forest-500 font-medium">Services</Link>
            <Link to="/contact" className="text-forest-700 hover:text-forest-500 font-medium">Contact</Link>
            <a href="tel:+14079063215" className="bg-forest-600 text-white px-4 py-2 rounded-md font-medium flex items-center hover:bg-forest-700 transition-colors duration-300">
              <Phone size={18} className="mr-2" /> Call Now
            </a>
          </nav>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className="text-forest-700 hover:text-forest-500 focus:outline-none"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    
      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-gray-100">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block text-forest-700 hover:bg-gray-200 px-3 py-2 rounded-md">Home</Link>
            <Link to="/services" className="block text-forest-700 hover:bg-gray-200 px-3 py-2 rounded-md">Services</Link>
            <Link to="/contact" className="block text-forest-700 hover:bg-gray-200 px-3 py-2 rounded-md">Contact</Link>
            <a href="tel:+14079063215" className="mt-2 block bg-forest-600 text-white hover:bg-forest-700 px-3 py-2 rounded-md flex items-center">
              <Phone size={18} className="mr-2" /> Call Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;